<div class="add-photo-dialog">
  <div class="dialog-header">
    <button type="button" mat-icon-button (click)="closeDialog()" aria-label="Close">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2>Add Issue Photo</h2>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-progress-bar *ngIf="submitting" mode="indeterminate"></mat-progress-bar>

    <div class="form-section">
      <div class="section-header">
        <span class="section-icon attachment">
          <mat-icon>photo_camera</mat-icon>
        </span>
        <span>Upload Photo</span>
      </div>

      <div class="form-group form-group--full">
        <label>Issue Photo</label>
        <div
          class="upload-zone"
          [class.drag-over]="isDragOver"
          (click)="triggerFileInput(fileInput)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p class="upload-text">Click to upload or drag and drop</p>
          <p class="upload-hint">Supported: image files</p>
          <input
            #fileInput
            type="file"
            class="file-input"
            accept="image/*"
            (change)="onFileSelect($event)" />
        </div>
      </div>

      <div *ngIf="issuePhotoPreview" class="preview-card">
        <div class="preview-image-wrap">
          <img [src]="issuePhotoPreview" alt="Issue photo preview" class="preview-image" />
        </div>
        <div class="preview-info">
          <div class="preview-details">
            <mat-icon>image</mat-icon>
            <span class="preview-name">{{ issuePhoto?.name || 'Selected image' }}</span>
          </div>
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="deleteFile(); $event.stopPropagation()"
            matTooltip="Remove image">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button type="button" class="cancel-button" mat-button (click)="closeDialog()">
      Cancel
    </button>
    <button
      type="button"
      class="submit-button"
      mat-flat-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!issuePhotoPreview || submitting">
      <span *ngIf="!submitting">Upload Photo</span>
      <span *ngIf="submitting">Uploading...</span>
    </button>
  </div>
</div>
